import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CampaignEntityService } from '../../../../module/campaign-util/shared/campaign-entity';

@Component({
  selector: 'photocode',
  templateUrl: './photocode.component.html',
  styleUrls: [ './photocode.component.scss' ]
})
export class PhotocodeComponent implements OnInit {

  campaign: any = {};
  @Input() code: string = '';
  @Input() search: boolean = false;

  constructor(protected toastrService: ToastrService,
              protected campaignEntityService: CampaignEntityService) {

  }

  ngOnInit() {
    this.campaignEntityService.getCampaign().subscribe((campaign: any) => {
      this.campaign = campaign;
    });
  }
}
